import * as React from 'react';
import Main from "../components/Main";
import {Col, Row} from "react-bootstrap";
import karta from "./../images/karta_klienta_KSK.png";
import kartaProfi from "./../images/karta_klienta_profi.png";

const KartyProfity = () => {
    return(
        <Main active={'KARTY_PROFITY'} title={'Karty Stałego Klienta'}>
            <h1 className={'sr-only'}>Karty Stałego Klienta</h1>
            <div className={'kartyProfity'}>
            <Row>
                <Col className={'colLeft'}>
                    <div style={{position: 'relative'}}>
                        <img src={karta} style={{width: '100%'}} alt={''}/>
                        <div className={'karta-podpis'}>
                            Karta Stałego Klienta
                            <h2 className={'h5 karta-podpis-tytul'}>DLA KAŻDEGO</h2>
                        </div>
                    </div>
                    <div className={'boxKartyProfity'} style={{color: '#bf0412'}}>
                        <span style={{fontSize: '16px', fontWeight: 'bold'}}>Rabaty do</span>
                        <div style={{fontSize: 'clamp(2.5rem, 8vw, 6rem)', fontWeight: 'bold', textAlign: 'center'}}>10%</div>
                    </div>
                    <div className={'boxKartyProfity'} style={{color: 'black'}}>
                        <div className={'srednie'}>Dostęp do aktualnych promocji</div>
                        <div className={'srednie'}><b>Kupuj taniej z kartą</b></div>
                        <div className={'male'}>(towary oznaczone w sklepach stacjonarnych)</div>
                        <div className={'srednie'}><b>Kupuj taniej z kuponem</b></div>
                    </div>
                    <div className={'boxKartyProfity'} style={{color: 'black'}}>
                        <div className={'srednie'}>Szybkie i łatwe zakupy w aplikacji</div>
                        <div className={'male'}>Z dostawą do domu lub z odbiorem w sklepie stacjonarnym</div>
                    </div>
                    <div className={'boxKartyProfity'} style={{color: 'black'}}>
                        <div className={'srednie'}>Dostęp do historii zakupów</div>
                        <div className={'male'}>Kontrolujesz swoje wydatki</div>
                    </div>
                    <div className={'regulamin'}>
                        Sczegóły promocji dostępne <b>w regulaminie Programu Lojalnościowego "Karta Stałego Klienta"</b>
                    </div>
                </Col>
                <Col className={'colRigth'}>
                    <div style={{position: 'relative'}}>
                        <img src={kartaProfi} style={{width: '100%'}} alt={''}/>
                        <div className={'karta-podpis'}>
                            Karta Stałego Klienta
                            <h2 className={'h5 karta-podpis-tytul'}>DLA FIRM - PROFI</h2>
                        </div>
                    </div>
                    <div className={'boxKartyProfity'} style={{color: 'black'}}>
                        <div style={{fontSize: 'clamp(1.75rem, 5vw, 4rem)', fontWeight: 'bold', textAlign: 'center'}}><span style={{fontSize: '16px'}}>Rabaty do </span> 7%</div>
                        <div style={{fontSize: 'clamp(1.75rem, 5vw, 4rem)', fontWeight: 'bold', textAlign: 'center'}}><span style={{fontSize: '16px'}}>+ Bon w aplikacji </span> 5%</div>
                        <div className={'male'}>Zbieraj punkty i wymieniaj bon rabatowy</div>
                    </div>
                    <div className={'boxKartyProfity'} style={{color: 'black'}}>
                        <div className={'srednie'}>Dostęp do aktualnych promocji</div>
                        <div className={'srednie'}><b>Kupuj taniej z kartą</b></div>
                        <div className={'male'}>(towary oznaczone w sklepach stacjonarnych)</div>
                        <div className={'srednie'}><b>Kupuj taniej z kuponem</b></div>
                    </div>
                    <div className={'boxKartyProfity'} style={{color: 'black'}}>
                        <div className={'srednie'}>Szybkie i łatwe zakupy w aplikacji</div>
                        <div className={'male'}>Z dostawą do domu lub z odbiorem w sklepie stacjonarnym</div>
                    </div>
                    <div className={'boxKartyProfity'} style={{color: 'black'}}>
                        <div className={'srednie'}>Dostęp do historii zakupów</div>
                        <div className={'male'}>Kontrolujesz swoje wydatki</div>
                    </div>
                    <div className={'boxKartyProfity'} style={{color: 'black'}}>
                        <div className={'srednie'}>Szeroka oferta specjalna</div>
                        <div className={'male'}>Indywidualne wyceny</div>
                    </div>
                    <div className={'boxKartyProfity'} style={{color: 'black'}}>
                        <div className={'srednie'}>Łatwy zwrot towaru</div>
                        <div className={'male'}>Nie wykorzystany towar możesz zwrócić</div>
                    </div>
                    <div className={'boxKartyProfity'} style={{color: 'black'}}>
                        <div className={'srednie'}>Transport w dniu zakupu</div>
                        <div className={'male'}>Liczymy się z Twoim czasem</div>
                    </div>
                    <div className={'regulamin'}>
                        Sczegóły promocji dostępne <b>w regulaminie Programu Lojalnościowego "Merkury Market Profi"</b>
                    </div>
                </Col>
            </Row>
            </div>
        </Main>
    )
}

export default KartyProfity;
